import { find, get } from 'lodash';
import { useContext } from 'react';
import { FooterMenuContext } from '../context/footer-menu-context';
import { useEnv } from '../hooks/use-env';
import { useMenus } from '../hooks/use-menus';
import { useSite } from '../hooks/use-site';
export var useFooterMenu = function () {
  var site = useSite();
  var env = useEnv();
  var allMenus = useMenus() || [];
  var context = useContext(FooterMenuContext);
  var menuSlug = get(site, 'footerMenu.slug', env.FOOTER_MENU_SLUG || '');
  var menu = find(allMenus, function (menu) {
    return menu.slug === menuSlug;
  });
  // legacy fallback
  return context || menu;
};